<div id="sentiment-container" [class.hidden]="isHidden">
    <div class="title">{{ title }}</div>
    <div class="legend-wrapper">
        <div class="legends">
            <div class="legend-item" *ngFor="let item of legendItems">
                <div class="color-box" [style.background]="item.color">
                    <ng-container *ngIf="toggleStatus">
                        <svg class="emoji-icon" *ngIf="getSentimentIcon(item.label)"
                            [ngStyle]="getSentimentIconStyle(item.label)">
                            <use [attr.href]="getSentimentIcon(item.label)"></use>
                        </svg>
                    </ng-container>
                </div>
                <div class="legend-label">
                    <div>{{ getLocalizedLabel(item.label) }}</div>
                    <div>{{ item.range }}</div>
                </div>
            </div>
        </div>

        <div class="toggle-section" *ngIf="showToggle">
            <div class="toggle-label">{{ toggleLabel }}</div>
            <div class="toggle-control">
                <sol-slide-toggle size="small" [(ngModel)]="toggleStatus" (ngModelChange)="onToggleChange($event)">
                </sol-slide-toggle>
                <span class="toggle-status-text">{{ toggleStatusText }}</span>
            </div>
        </div>
    </div>
</div>